export default "__VITE_ASSET__BU8G9Vd5__"